<template>
  <div class="weboffice-container">
      <div id="webnotifyspan" style="display: none" />
      <el-button v-show="false" id="btnWpsSaved" type="default" @click="btnWpsSavedClick" />
      <el-dialog :title="$tx('common.operationTip', '操作提示')" :visible.sync="loadingShow" width="400px" :before-close="handleClose">
          <div v-text-lbl="'reloadMsg3'" style="height: 80px; line-height: 80px; text-align: center">正在打开，请稍后...</div>
      </el-dialog>
  </div>
</template>

<script>
// import { wpsInstallAddin } from './wpsInit'
import { getSaveAsFileName, formatTime } from '@/global/utils/index'
const { bodyDocHistoryVer } = require('@/wapp/settings')

export default {
    name: 'WpsOffice',
    props: {
        bodyfile: {
            type: Object,
            default: function () {
                return null
            }
        },
        commandBar: {
            type: Array,
            default: function () {
                return null
            }
        }
    },
    data: function () {
        return {
            i18npkg: 'ecoa',
            moduleCode: 'webOffice',
            bodyDocHistoryVer: bodyDocHistoryVer,
            fanwen_url: '',
            loadingShow: false,
            WFBodyDocId: '',
            openType: '',
            loginUser: this.$store.getters.loginUser,
            isEvenNumberPage: 0, // 是否偶数页面
            disableHgbtn: false
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('btnOpenWordClick', this.btnOpenWpsClick)
        this.$bus.on('btnModifyFlTypeClick', this.btnModifyFlTypeClick)
        this.$bus.on('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
        this.$bus.on('btnCreateCpbClick', this.btnCreateCpbClick)
        this.$bus.on('btnPreviewAttachClick', this.btnPreviewAttachClick)
        this.$bus.on('btnEditAttachClick', this.btnEditAttachClick)
        this.getHgbtnStatus()
    },
    beforeDestroy() {
        this.$bus.off('btnOpenWordClick', this.btnOpenWpsClick)
        this.$bus.off('btnModifyFlTypeClick', this.btnModifyFlTypeClick)
        this.$bus.off('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
        this.$bus.off('btnCreateCpbClick', this.btnCreateCpbClick)
        this.$bus.off('btnPreviewAttachClick', this.btnPreviewAttachClick)
        this.$bus.off('btnEditAttachClick', this.btnEditAttachClick)
    },
    mounted() {
        const { wpsInstallAddin } = require('./wpsInit.js')
        wpsInstallAddin((res) => {
            console.log('检测是否安装WPS', res)
            document.querySelector('#webnotifyspan').innerText = ''
        })
    },
    methods: {
        btnEditAttachClick(attach, officeType) {
            const $scope = this.$vnode.context
            this.btnOpenWpsClickReal($scope, officeType, attach)
        },
        // 套红事件
        /**
       * redTitle 模式 更换红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        btnModifyFlTypeClick($scope) {
            this.validateEditModeWithPrompt($scope)
        },
        /**
       * NoTitle 模式 套红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        btnNoTitleModifyFlTypeClick($scope) {
            this.validateEditModeWithPrompt($scope)
        },
        /**
       * 查询红头模版前的校验操作 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        validateEditModeWithPrompt($scope) {
            // 非内嵌需带上此校验
            if ($scope.InlineTextEditor) {
                return
            }
            let confirmMessage, officeType

            if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                if ($scope.vo.signedFileName) {
                    // 简化条件判断
                    // confirmMessage = '该公文已经盖章，重新编辑正文后需要重新盖章！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.signedFileNameConfirm', '该公文已经盖章，重新编辑正文后需要重新盖章！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'RedliningOnce' // 如果是在NoTitle模式下，并且有签名文件，则使用'RedliningOnce'
                } else if ($scope.wfInstance.haveDoc === 2) {
                    // confirmMessage = '该公文已经套过红！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.haveDocConfirm', '该公文已经套过红！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'Redlining' // 如果是NoTitle模式下且再次套红（haveDoc为2），则使用'Redlining'
                } else {
                    officeType = 'Redlining' // 否则默认使用'Redlining'
                }
            } else {
                if ($scope.vo.signedFileName) {
                    // confirmMessage = '该公文已经盖章，重新编辑正文后需要重新盖章！<br>是否继续？'

                    confirmMessage = this.$tx('ecoa.webOffice.signedFileNameConfirm', '该公文已经盖章，重新编辑正文后需要重新盖章！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'OpenTwoDoc' // 如果不是NoTitle模式下，且有签名文件，则使用'OpenTwoDoc'
                } else {
                    officeType = 'OpenTwoDoc' // 否则默认使用'OpenTwoDoc'
                }
            }

            if (confirmMessage) {
                this.$confirm(confirmMessage, this.$tx('common.confirmOperate', '确认操作'), { type: 'warning', dangerouslyUseHTMLString: true })
                    .then(() => {
                        this.ModifyFlTypeClick($scope, officeType)
                    })
                    .catch(() => {
                        return
                    })
            } else {
                // 如果没有需要确认的消息，则直接调用函数
                this.ModifyFlTypeClick($scope, officeType)
            }
        },
        /**
       * 选择红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        ModifyFlTypeClick($scope, officeType) {
            this.fetchFwmbTemplateData($scope).then((res) => {
                if (res.code === 'success') {
                    // 匹配文件字号相同的红头模版，并设置所有模板的value和text属性
                    let mbList = []
                    if ($scope.vo && $scope.vo.flWord) {
                        // 过滤出文件字号相同的红头模版
                        mbList = res.body.listdata.filter((item) => item.fileWord === $scope.vo.flWord)

                        // 如果找到了匹配的模版，则替换res.body.listdata
                        if (mbList.length > 0) {
                            res.body.listdata = mbList
                        }
                    }
                    // 无论是否找到了匹配的模版，都设置所有模板的value和text属性
                    res.body.listdata.forEach((item) => {
                        item.value = item.id
                        item.text = item.name
                    })

                    if (res.body.listdata.length > 1) {
                        this.$bus.emit(
                            'openListitemDialog',
                            '选择红头模板',
                            res.body.listdata,
                            (rst) => {
                                if (rst.code === 'success') {
                                    const gwmb = res.body.listdata.filter((item) => {
                                        if (item.id === rst.value) return true
                                    })
                                    this.validateAndEditFwmbTemplate($scope, gwmb, officeType)
                                }
                            },
                            $scope.vo.gwmbId,
                            '红头模板',
                            '请选择红头模板'
                        )
                    } else if (res.body.listdata.length === 1) {
                        // 调用选择模版后处理方法

                        this.validateAndEditFwmbTemplate($scope, res.body.listdata, officeType)
                    }
                } else {
                    // this.$alert(res.message, '操作提示', { type: 'error' })
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        },
        /**
       * 请求发文模版数据 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        fetchFwmbTemplateData($scope) {
            return this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'sortNo,name' },
                data: [
                    { compare: '=', field: 'orgCode', value: $scope.wfInstance.orgCode },
                    { compare: '=', field: 'status', value: 1 }
                ],
                url: 'gwgl/fwmb/querydata'
            })
        },
        /**
       * 拿到红头模版后的调用编辑正文操作 -- wpsjs方法
       * @param {*} $scope
       */
        validateAndEditFwmbTemplate($scope, gwmb, officeType) {
            $scope.vo.flWord = gwmb[0].fileWord
            $scope.vo.flFormName = gwmb[0].formTitle
            $scope.vo.flRedTitle = gwmb[0].fileHeader
            $scope.vo.gwmbId = gwmb[0].id
            $scope.vo.flType = gwmb[0].name
            this.isEvenNumberPage = gwmb[0].isEvenNumberPage

            this.btnOpenWpsClickReal($scope, officeType)
        },

        btnCreateCpbClick($scope, openType) {
            this.btnOpenWpsClick($scope, openType)
        },
        // // 附件编辑方法
        // btnEditAttachClick(attach, officeType) {
        //     // 安装了wps并且officeType==='wpsjs'
        //     const $scope = this.$vnode.context
        //     if (window.wpsInstalled && $scope.officeType === 'wpsjs') {
        //         // this.btnOpenWpsClickReal($scope, openType)
        //         this.btnOpenWpsClickReal($scope, officeType, attach)
        //     }
        // },
        btnOpenWpsClick($scope, openType, fbUrl) {
            this.fanwen_url = fbUrl
            // 安装了wps并且officeType==='wpsjs'
            if (window.wpsInstalled && $scope.officeType === 'wpsjs') {
                this.btnOpenWpsClickReal($scope, openType)
            }
        },
        btnOpenWpsClickReal($scope, openType, attach) {
            // 编辑正文事件
            $scope.formValidate(() => {
                const appUrl = location.href.split('#')[0]
                const WFBusiDataId = $scope.vo.id
                let WFBodyDocId = $scope.wfInstance.bodyDocId ? $scope.wfInstance.bodyDocId : ''
                this.WFBodyDocId = WFBodyDocId
                const WfModule = $scope.wfInstance.module ? $scope.wfInstance.module : ''
                let attachsType = 'BODY'
                let attachsName = WFBodyDocId + '.doc'

                //Wpsjs编辑器，标题栏显示使用saveAs下载保存到本机的文件名，上传使用attachNames
                let saveAs = $scope.vo.flSubject + '.doc'
                if (typeof getSaveAsFileName === 'function') {
                    saveAs = getSaveAsFileName(saveAs)
                }
                if (openType === 'NoTracks') {
                    attachsName = 'NoTracks_' + attachsName
                } else if (openType === 'Redlining' || (openType === 'RedliningOnce' && $scope.wfInstance.passenger.docEditMode === 'NoTitle')) {
                    attachsName = 'RedTitle_' + attachsName
                }
                if (attach) {
                    attachsType = attach.fileType
                    attachsName = attach.fileName
                } else if (openType === 'attachEdit') {
                    attachsType = 'ATTACH'
                }

                let bOpenRevision = false
                if ($scope.wfInstance.status > 0) {
                    bOpenRevision = true
                }

                this.openType = openType

                // 使用正文pdf，测试核稿
                /* $scope.approveFile = $scope.bodyfile
              openType = 'Approve'*/
                var uploadPath = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/upload?bodyDocId=' + WFBodyDocId + '&busiDataId=' + WFBusiDataId + '&module=' + WfModule

                let downUrl = '' // doc正文下载url
                let oldFileDownUrl = '' // 核稿旧文件下载url
                let approveFileDownUrl = '' // 领导手写签批文件下载url
                let insertFileUrl = '' // 指定的红头模板'

                if (openType === 'NoTracks') {
                    //清稿
                    if ($scope.noTracksFile && $scope.noTracksFile.fileName) {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY'
                    } else {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                    }
                } else if (attach) {
                    bOpenRevision = false
                    downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + attach.busiDataId + '&attachsName=' + encodeURIComponent(attach.fileName) + '&attachsType=ATTACH'
                } else if (openType === 'OpenTwoDoc') {
                    bOpenRevision = false
                    if ($scope.noTracksFile) {
                        oldFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY'
                    } else {
                        oldFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                    }
                    oldFileDownUrl += '&saveAs=旧文件.doc'
                    if ($scope.vo.gwmbId !== undefined && $scope.vo.gwmbId !== null && $scope.vo.gwmbId !== '') {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName'
                    } else {
                        downUrl = appUrl + 'templates/Editor.doc?t=1'
                    }
                } else if (openType === 'Approve' && $scope.approveFile) {
                    bOpenRevision = false
                    approveFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadById?inline=true&attachIds=' + $scope.approveFile.id + '&widthType=pageWidth'

                    if ($scope.noTracksFile) {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY'
                    } else {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                    }
                } else if (openType === 'Redlining' || openType === 'RedliningOnce') {
                    uploadPath = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/upload?busiDataId=' + WFBusiDataId + '&module=' + WfModule
                    downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName'

                    if ($scope.wfInstance.haveDoc === 0) {
                        // 初始化套红  Redlining
                        insertFileUrl = appUrl + 'templates/Editor.doc?t=1' // 首次进来且套红                 '
                        uploadPath += '&Redlining=Redlining'
                    } else if ($scope.wfInstance.haveDoc === 1) {
                        // 首次套红  Redlining
                        if ($scope.noTracksFile && $scope.noTracksFile.fileName) {
                            insertFileUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY'
                        } else {
                            insertFileUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                        }
                        uploadPath += '&Redlining=Redlining'
                    } else if ($scope.wfInstance.haveDoc === 2) {
                        // 再次套红  RedliningOnce
                        if ($scope.noTracksFile && $scope.noTracksFile.fileName) {
                            insertFileUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY'
                        } else {
                            insertFileUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                        }
                        uploadPath += '&Redlining=RedliningOnce'
                    }
                } else if (openType === 'attachEdit') {
                    // 附件编辑
                    // saveAs = $scope.vo.mbFileName ? $scope.vo.mbFileName : $scope.vo.name + '-' + $scope.vo.mbVer
                    saveAs = $scope.vo.id ? $scope.vo.id + '.docx' : $scope.vo.mbFileName

                    downUrl = $scope.downUrl + '&attachsName=' + WFBodyDocId
                    uploadPath = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/upload'
                } else if (openType !== undefined && openType !== 'OpenTwoDoc' && openType !== 'Approve') {
                    if ($scope.wfInstance.status === -1) {
                        // this.$alert('请先保存文件。', '操作提示', { type: 'warning' })
                        this.$alert(this.$tx('ecoa.webOffice.saveFileAlert', '请先保存文件。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })

                        return
                    } else if ($scope.vo.flCpbTemplateId && $scope.vo.flCpbTemplateId !== '') {
                        bOpenRevision = false
                        attachsType = openType
                        attachsName = openType + '_' + WFBodyDocId + '.doc'
                        let productCode = sessionStorage.getItem('productCode')
                        if (!productCode) {
                            productCode = window.productCode
                        }
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/cpbFile/printCpbFileDoc?busiDataId=' + $scope.vo.id + '&cpbTemplateId=' + $scope.vo.flCpbTemplateId + `&productCode=${productCode}`
                    } else {
                        // this.$alert('当前文件没有关联呈批表/拟稿纸模板。', '操作提示', { type: 'warning' })
                        this.$alert(this.$tx('ecoa.webOffice.errorLinkFormAlert', '当前文件没有关联呈批表/拟稿纸模板。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                        return
                    }
                } else if ($scope.wfInstance.haveDoc === 0) {
                    // 初始进来 haveDoc = 0
                    if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                        downUrl = appUrl + 'templates/Editor.doc?t=1'
                    } else {
                        if ($scope.vo.gwmbId && $scope.vo.gwmbId !== null && $scope.vo.gwmbId !== '') {
                            downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName'
                        } else {
                            downUrl = appUrl + 'templates/Editor.doc?t=1'
                        }
                    }
                } else {
                    downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                }
                if (downUrl.indexOf('&saveAs=') === -1) {
                    downUrl += '&saveAs=' + saveAs
                }

                // 使用范文
                if (this.fanwen_url) downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + this.fanwen_url

                // 文件附件，每个附件一行
                let attachNames = ''
                if ($scope.attachments) {
                    let index = 1
                    $scope.attachments.forEach((attach) => {
                        if (attach.fileType === 'ATTACH') {
                            attachNames += index++ + '、' + attach.fileName + '<br/>'
                        }
                    })
                    // 将<br/>转换为word可识别的换行符
                    let blankDiv = document.querySelector('.convert-br-div')
                    if (!blankDiv) {
                        blankDiv = document.createElement('div')
                        blankDiv.classList.add('convert-br-div')
                        document.body.appendChild(blankDiv)
                    }
                    blankDiv.innerHTML = attachNames
                    attachNames = blankDiv.innerText
                }

                this.$http({
                    method: 'GET',
                    params: { timeLength: 60 },
                    url: 'base/user/getSessionId'
                }).then((res) => {
                    if (res.code === 'success') {
                        let productCode = ''
                        // sessionStorage.getItem('productCode')
                        if (!productCode) {
                            productCode = window.productCode
                        }
                        if (productCode !== '') {
                            if (uploadPath.indexOf('?') === -1) {
                                uploadPath += '?productCode=' + productCode
                            } else {
                                uploadPath += '&productCode=' + productCode
                            }
                        }
                        if (attachsType === 'BODY') {
                            uploadPath += '&attachsName=' + attachsName + '&attachsType=' + attachsType + '&tSessionId=' + res.body.tSessionId + '&bodyDocId=' + $scope.wfInstance.bodyDocId
                        } else if (openType === 'attachEdit') {
                            uploadPath += '&' + $scope.uploadUrl + '&attachsName=' + WFBodyDocId + '&attachsType=' + attachsType + '&tSessionId=' + res.body.tSessionId + '&topdf=false'
                        } else {
                            uploadPath += '&attachsName=' + attachsName + '&attachsType=' + attachsType + '&tSessionId=' + res.body.tSessionId + '&topdf=false'
                        }

                        //启用编辑正文历史版本保存功能
                        if (!openType) {
                            if (this.bodyDocHistoryVer === 'everySave') {
                                //每次编辑正文保存一个版本
                                uploadPath += '&fileId=' + WFBodyDocId + '&fileVer=' + formatTime(new Date(), 'YYYYMMDDHHmmss')
                            } else if (this.bodyDocHistoryVer === 'everyTaskNode' && $scope.curTN.tnStartTime) {
                                //版本号为当前环节开始时间，一个环节处理人只保留一个历史版本
                                uploadPath += '&fileId=' + WFBodyDocId + '&fileVer=' + $scope.curTN.tnStartTime.replaceAll('-', '').replaceAll(' ', '').replaceAll(':', '').replace('.', '')
                            }
                        }
                        var uploadAppendPath = uploadPath.replace(WFBodyDocId + '.doc', WFBodyDocId + '.pdf')
                        if (attach || openType === 'PrintFile') uploadAppendPath = ''

                        var filePath = downUrl + '&tSessionId=' + res.body.tSessionId
                        var uploadFieldName = 'file'
                        var bkInsertFile = ''

                        if (oldFileDownUrl !== '') oldFileDownUrl += '&tSessionId=' + res.body.tSessionId

                        if (insertFileUrl !== '') {
                            insertFileUrl += '&tSessionId=' + res.body.tSessionId
                            bkInsertFile = 'Body' // 套红位置
                        }

                        if (approveFileDownUrl !== '') {
                            approveFileDownUrl = approveFileDownUrl = appUrl + 'plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(approveFileDownUrl + '&tSessionId=' + res.body.tSessionId)
                        }

                        const disableBtns = 'btnChangeToPDF,btnChangeToOFD' // 禁止显示的按钮
                        // if (attachsType !== 'BODY') {
                        //     disableBtns = 'btnSaveToServer,btnPauseSaveToServer,btnChangeToOFD'
                        // }

                        const bookmarks = []
                        const moment = require('moment')
                        const flCreateDate = moment($scope.vo.flCreateDate).format('YYYY年MM月DD日')
                        const flSignDate = $scope.vo.flSignDate ? moment($scope.vo.flSignDate).format('YYYY年MM月DD日') : null

                        bookmarks.push({ bookName: 'FlSubject', bookValue: $scope.vo.flSubject == null ? '' : $scope.vo.flSubject })
                        bookmarks.push({ bookName: 'FlCreateDate', bookValue: flCreateDate == null ? '' : flCreateDate })
                        bookmarks.push({ bookName: 'FlCreator', bookValue: $scope.vo.flCreator == null ? '' : $scope.vo.flCreator })
                        bookmarks.push({ bookName: 'FlCreatorPhone', bookValue: $scope.vo.flCreatorPhone == null ? '' : $scope.vo.flCreatorPhone })
                        bookmarks.push({ bookName: 'FlJbr', bookValue: $scope.vo.flJbr == null ? '' : $scope.vo.flJbr })
                        bookmarks.push({ bookName: 'FlMainSend', bookValue: $scope.vo.flMainSend == null ? '' : $scope.vo.flMainSend })
                        bookmarks.push({ bookName: 'FlSignOrg', bookValue: $scope.vo.flSignOrg == null ? '' : $scope.vo.flSignOrg })
                        bookmarks.push({ bookName: 'Copies', bookValue: $scope.vo.flPrintCount == null ? '' : $scope.vo.flPrintCount + '' })
                        bookmarks.push({ bookName: 'FileCode', bookValue: $scope.vo.flFwzh == null ? '' : $scope.vo.flFwzh })
                        bookmarks.push({ bookName: 'FlCopySend', bookValue: $scope.vo.flCopySend == null ? '' : $scope.vo.flCopySend })
                        bookmarks.push({ bookName: 'FlSignDate', bookValue: flSignDate == null ? '' : flSignDate })
                        bookmarks.push({ bookName: 'FlPrintTime', bookValue: $scope.vo.flPrintTime == null ? '' : $scope.vo.flPrintTime })
                        bookmarks.push({ bookName: 'AttachNames', bookValue: attachNames })

                        if ($scope.wfInstance.module === 'hytz') {
                            bookmarks.push({ bookName: 'StartTime', bookValue: $scope.vo.startTime == null ? '' : $scope.vo.startTime.substring(0, 16) })
                            bookmarks.push({ bookName: 'EndTime', bookValue: $scope.vo.endTime == null ? '' : $scope.vo.endTime.substring(0, 16) })
                            bookmarks.push({ bookName: 'Address', bookValue: $scope.vo.address == null ? '' : $scope.vo.address })
                            bookmarks.push({ bookName: 'Compere', bookValue: $scope.vo.compere == null ? '' : $scope.vo.compere })
                            bookmarks.push({ bookName: 'Body', bookValue: $scope.vo.lContent == null ? '' : $scope.vo.Body })
                            bookmarks.push({ bookName: 'Leaders', bookValue: $scope.vo.leaders == null ? '' : $scope.vo.leaders })
                            bookmarks.push({ bookName: 'tixingshijian', bookValue: $scope.vo.flRegistTime == null ? '' : $scope.vo.flRegistTime.substring(0, 16) })
                            bookmarks.push({ bookName: 'flSignOrg', bookValue: $scope.wfInstance.orgName })
                            bookmarks.push({ bookName: 'fabushijian', flCreateDate })
                        }

                        if (openType !== 'attachEdit' && openType !== 'PrintFile') {
                            // 启用后端上传文件权限校验功能，编辑正文时，禁止提交后再上传正文
                            uploadPath += '&tnkey=' + $scope.curTN.staffID + '_' + $scope.curTN.tnID
                        }
                        let appendSuffix = '.pdf'
                        if (attach) {
                            appendSuffix = '.' + attach.fileName.split('.')[1]
                        }

                        // 默认不显示修订
                        let bShowRevision = false
                        if ($scope.wfInstance.status < 1) {
                            //拟稿不记录修订
                            bOpenRevision = false
                        } else {
                            //审核环节记录修订
                            bOpenRevision = true
                        }
                        if (openType === 'NoTracks') {
                            //清稿显示历史修订
                            bOpenRevision = false
                            bShowRevision = true
                        }

                        window._WpsInvoke([
                            {
                                OnlineEditDoc: {
                                    docId: attachsName, // 使用上传文件名做为文档ID   必传
                                    appendSuffix: appendSuffix, // 版式文件格式
                                    uploadPath: uploadPath, // 保存文档上传路径
                                    uploadAppendPath: uploadAppendPath,
                                    uploadFileName: attachsName,
                                    fileName: filePath, // 打开的文档路径
                                    attachsType: attachsType,
                                    oldFileDownUrl: oldFileDownUrl,
                                    // 'approveFileDownUrl': approveFileDownUrl,//禁用核稿功能
                                    uploadFieldName: uploadFieldName,
                                    buttonGroups: disableBtns, // 屏蔽功能按钮
                                    userName: $scope.curTN && $scope.curTN.userName ? $scope.curTN.userName : this.loginUser.personName,
                                    revisionCtrl: {
                                        bOpenRevision: bOpenRevision, // true 打开修订，false关闭修订
                                        bShowRevision: bShowRevision // true 显示修订，false隐藏修订
                                    },
                                    bookmarks: bookmarks,
                                    bkInsertFile: bkInsertFile, // 套红书签位置
                                    insertFileUrl: insertFileUrl, // 指定的红头模板
                                    evenNumberPageSize: String(this.isEvenNumberPage), // 最后一页是否必须偶数页，1：是，0：否
                                    getTaskIdUrl: location.href.split('#')[0] + process.env.VUE_APP_BASE_API.substring(1) + '/hegao/forwardmethodtohg?tSessionId=' + res.body.tSessionId,
                                    proofreadingUrl: location.href.split('#')[0] + process.env.VUE_APP_BASE_API.substring(1) + '/hegao/getTaskDetail?tSessionId=' + res.body.tSessionId,
                                    wfInstance: JSON.stringify($scope.wfInstance),
                                    bodyfile: JSON.stringify($scope.bodyfile),
                                    wfAttachUrl: $scope.wfAttachUrl,
                                    disableHgbtn: this.disableHgbtn
                                }
                            }
                        ]) // onlineEditDoc方法对应于OA助手dispatcher支持的方法名
                    }
                })
            })
        },
        btnPreviewAttachClick(attach, onlineEditor) {
            const $scope = this.$vnode.context
            const WFBodyDocId = $scope.wfInstance.bodyDocId
            this.$http({
                method: 'GET',
                url: 'base/user/getSessionId'
            }).then((res) => {
                if (res.code === 'success') {
                    const tSessionId = res.body.tSessionId
                    const hostname = location.href.split('#')[0]
                    const downUrl = hostname.substring(0, hostname.length - 1) + process.env.VUE_APP_BASE_API + '/' + $scope.wfAttachUrl + '/downloadById?attachIds=' + attach.id + '&httpPort=' + location.port + '&tSessionId=' + tSessionId
                    const disableBtns = 'btnSaveToServer,btnPauseSaveToServer,btnChangeToPDF,btnChangeToOFD'
                    window._WpsInvoke([
                        {
                            OnlineEditDoc: {
                                docId: WFBodyDocId, // 文档ID
                                fileName: encodeURI(downUrl),
                                buttonGroups: disableBtns, // 屏蔽功能按钮
                                userName: $scope.curTN.userName,
                                revisionCtrl: {
                                    bOpenRevision: false, // true 打开修订，false关闭修订
                                    bShowRevision: false // true 显示修订，false隐藏修订
                                },
                                bookmarks: []
                            }
                        }
                    ])
                }
            })
        },
        btnOpenOldVersionDoc(oldFileDownUrl) {
            if (oldFileDownUrl === '') return

            // 修改红头打开个版本带正文内容文件
            const $scope = this.$vnode.context
            const WFBodyDocId = $scope.wfInstance.bodyDocId

            const disableBtns = 'btnSaveToServer,btnPauseSaveToServer,btnChangeToPDF,btnChangeToOFD'
            window._WpsInvoke([
                {
                    OnlineEditDoc: {
                        docId: WFBodyDocId + '_old', // 文档ID
                        fileName: encodeURI(oldFileDownUrl),
                        buttonGroups: disableBtns, // 屏蔽功能按钮
                        userName: $scope.curTN.userName,
                        revisionCtrl: {
                            bOpenRevision: false, // true 打开修订，false关闭修订
                            bShowRevision: false // true 显示修订，false隐藏修订
                        },
                        bookmarks: []
                    }
                }
            ])
        },
        btnWpsSavedClick() {
            const saveInfo = JSON.parse(document.querySelector('#webnotifyspan').innerText)
            let $scope = {}
            if (this.$vnode.context.wfInstance && this.$vnode.context.wfInstance.busiDataId) {
                $scope = this.$vnode.context
            } else if (this.$vnode.context.$vnode.context.wfInstance && this.$vnode.context.$vnode.context.wfInstance.busiDataId) {
                $scope = this.$vnode.context.$vnode.context
            } else {
                $scope = this.$vnode.context
            }

            const _this = this
            if (saveInfo.uploadPath && saveInfo.uploadPath.indexOf($scope.wfInstance ? $scope.wfInstance.busiDataId : 'none') !== -1) {
                const urlParams = new URLSearchParams(saveInfo.uploadPath.split('?')[1]) // 解析地址获取参数
                const params = {}
                for (const param of urlParams) {
                    params[param[0]] = param[1]
                }

                if (saveInfo.code === 'uploading' && saveInfo.attachsType === 'BODY') {
                    _this.uploadedAttachs = saveInfo.attachs
                } else if (saveInfo.code === 'success' && saveInfo.afterPDF && saveInfo.attachsType === 'BODY') {
                    if (_this.uploadedAttachs) {
                        _this.uploadedAttachs.push(...saveInfo.attachs)
                    }

                    if (this.openType === 'NoTracks') {
                        // 清稿结束
                        $scope.wfInstance.haveDoc = 1
                        if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                    } else if (this.openType === 'Redlining' || this.openType === 'RedliningOnce') {
                        // 套红或重新套红
                        $scope.wfInstance.haveDoc = 2
                        if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                    } else if (this.openType === 'SignedFile') {
                        // 盖章
                        $scope.vo.signedFileName = attachs[0].fileName
                    } else {
                        // 编辑正文
                        if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                            // NoTitle 模式下 haveDoc 编辑后为 1
                            $scope.wfInstance.haveDoc = 1
                        } else {
                            $scope.wfInstance.haveDoc = 2
                        }
                        if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                    }

                    $scope.$message({
                        type: 'success',
                        message: this.$tx('ecoa.webOffice.fileSaveSuccessMsg', '文件已保存成功！'),
                        showClose: true
                    })
                    window._WpsInvoke([
                        {
                            ExitWPS: {}
                        }
                    ])

                    //切换到正文标签，加载正文
                    if (!_this.uploadedAttachs) {
                        localStorage.setItem('activeName', 1)
                        $scope.btnSubmitClick('SaveAndReload')
                    } else {
                        $scope.activeName = 'second'
                        _this.$nextTick(() => {
                            _this.$bus.emit('reloadBodyFile', _this.uploadedAttachs)
                            $scope.btnSubmitClick('AutoSave')
                        })
                    }
                }
            } else if (saveInfo.code === 'success') {
                window._WpsInvoke([
                    {
                        ExitWPS: {}
                    }
                ])
                // $scope.$message.success('文件已保存成功！')
                $scope.$message.success(this.$tx('ecoa.webOffice.fileSaveSuccessMsg'))
            }
        },
        // 查询是否只启用核稿功能
        getHgbtnStatus() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { orgCode: 'plat', paramNames: 'bodyfile.correct.targetPageUrl' },
                url: 'base/paramConfig/findParamConfigByParamNames'
            }).then((res) => {
                if (res.code === 'success') {
                    if (!res.body.params['bodyfile.correct.targetPageUrl']) {
                        this.disableHgbtn = true
                    }
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.weboffice-container {
  margin: 0;
}
.isform {
  .weboffice-container {
      border: 1px solid #999;
      border-top: 0px;
  }
}
</style>
